import React, { useState } from "react";
import { motion } from "framer-motion";
import { Send, Mail } from "lucide-react";
import { BRAND, CONTACT_SERVICES } from "@/data/content";

export const ContactWhatsApp = () => {
  const [name, setName] = useState("");
  const [service, setService] = useState(CONTACT_SERVICES[0]);
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const text = `¡Hola Polaris! 👋%0A%0AMi nombre es ${encodeURIComponent(
      name || "—"
    )}.%0AMe interesa: ${encodeURIComponent(service)}.%0A%0A${encodeURIComponent(
      message || "Me gustaría más información."
    )}`;
    window.open(`https://wa.me/${BRAND.whatsapp}?text=${text}`, "_blank");
  };

  const handleEmail = () => {
    const subject = encodeURIComponent(`Consulta: ${service}`);
    const body = encodeURIComponent(
      `Hola Polaris,\n\nMi nombre es ${name || "—"}.\nMe interesa: ${service}.\n\n${
        message || "Me gustaría más información."
      }`
    );
    window.location.href = `mailto:${BRAND.email}?subject=${subject}&body=${body}`;
  };

  return (
    <section id="contacto" className="py-20 md:py-28 bg-[#fbf7f1]">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center">
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#12b2a0]">
            Hablemos
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight mt-4 leading-tight">
            Escríbenos por WhatsApp
          </h2>
          <p className="mt-5 text-lg text-[#6b6873] leading-relaxed">
            Cuéntanos qué necesitas y te respondemos directo a tu chat. Sin formularios eternos.
          </p>
        </div>

        <motion.form
          onSubmit={handleSubmit}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          data-testid="whatsapp-form"
          className="mt-12 bg-white border border-[#e4dccf] rounded-3xl p-8 md:p-10 space-y-6"
        >
          <div>
            <label className="text-sm font-semibold text-[#2b2a33]">Tu nombre</label>
            <input
              type="text"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              data-testid="contact-name"
              placeholder="¿Cómo te llamas?"
              className="mt-2 w-full bg-[#fbf7f1] border border-[#e4dccf] rounded-xl px-4 py-3.5 outline-none focus:border-[#ff5c49] transition-colors"
            />
          </div>

          <div>
            <label className="text-sm font-semibold text-[#2b2a33]">¿Qué te interesa?</label>
            <select
              value={service}
              onChange={(e) => setService(e.target.value)}
              data-testid="contact-service"
              className="mt-2 w-full bg-[#fbf7f1] border border-[#e4dccf] rounded-xl px-4 py-3.5 outline-none focus:border-[#ff5c49] transition-colors"
            >
              {CONTACT_SERVICES.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-sm font-semibold text-[#2b2a33]">Tu mensaje</label>
            <textarea
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              data-testid="contact-message"
              placeholder="Cuéntanos un poco sobre tu proyecto…"
              className="mt-2 w-full bg-[#fbf7f1] border border-[#e4dccf] rounded-xl px-4 py-3.5 outline-none focus:border-[#ff5c49] transition-colors resize-none"
            />
          </div>

          <button
            type="submit"
            data-testid="whatsapp-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-semibold px-7 py-4 rounded-full hover:bg-[#1fb955] transition-colors"
          >
            <Send className="w-5 h-5" /> Enviar por WhatsApp
          </button>

          <button
            type="button"
            onClick={handleEmail}
            data-testid="email-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-white border border-[#2b2a33]/15 text-[#2b2a33] font-semibold px-7 py-4 rounded-full hover:border-[#2b2a33] transition-colors"
          >
            <Mail className="w-5 h-5" /> Enviar por correo
          </button>

          <p className="text-center text-sm text-[#6b6873]">
            O escríbenos directo a{" "}
            <a
              href={`mailto:${BRAND.email}`}
              data-testid="contact-email-link"
              className="font-semibold text-[#ff5c49] hover:underline"
            >
              {BRAND.email}
            </a>
          </p>
        </motion.form>
      </div>
    </section>
  );
};
